import { render } from "./FormNewPasswordComponent.vue?vue&type=template&id=3bdc8feb&scoped=true"
import script from "./FormNewPasswordComponent.vue?vue&type=script&lang=js"
export * from "./FormNewPasswordComponent.vue?vue&type=script&lang=js"

import "./FormNewPasswordComponent.vue?vue&type=style&index=0&id=3bdc8feb&scoped=true&lang=css"

import exportComponent from "/Users/daniel/Documents/CETECREA/cetecrea/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3bdc8feb"]])

export default __exports__